import React from 'react';
import { MockParliment2026 } from '../views';


const MobileAppPage = () => {
  return <MockParliment2026/>;
};

export default MobileAppPage;
